import { hasProperty } from "../../../helpers";
import { Tag } from "@matterport/webcomponent";

export interface MattertagAssetLink {
  clientAssetCode?: string;
  assetName?: string;
  assetId?: number;
  widgetId?: number;
  tagIds?: number[];
  error?: string;
}

function isMattertagAssetLink(obj: any): boolean {
  if (obj === null) {
    return false;
  }

  return (
    hasProperty(obj, "clientAssetCode", "string") ||
    hasProperty(obj, "assetName", "string") ||
    hasProperty(obj, "assetId", "number") ||
    hasProperty(obj, "widgetId", "number") ||
    hasProperty(obj, "tagIds", "object")
  );
}

export function parseMattertagAssetLink(
  mattertag: Tag.TagData,
): MattertagAssetLink {
  const description = (mattertag.description ?? "").trim();
  const json = description.substring(
    description.indexOf("{"),
    description.lastIndexOf("}") + 1,
  );

  try {
    const obj = json !== "" ? JSON.parse(json) : null;
    if (isMattertagAssetLink(obj)) {
      return obj as MattertagAssetLink;
    }
    return {
      error:
        "We couldn't find any Helix configuration in this Mattertag's" +
        " description so no widget will be displayed.",
    };
  } catch (error) {
    console.error(
      "The following error occurred when attempting to parse a Mattertag's " +
        "description:",
      error,
    );
    if (error.message.startsWith("SyntaxError")) {
      return {
        error:
          "The JSON we found in this Mattertag's description was " +
          "malformed. See the console for a detailed error message.",
      };
    }
    return {
      error:
        "An unknown error occurred when attempting to parse this Mattertag's " +
        "description. See the console for a detailed error message.",
    };
  }
}
